export const usePasswordReset = () => {
  const loading = ref(false)
  const error = ref(null)
  const requestPasswordReset = async (params: {
    email: string
    reseturl: string
  }) => {
    try {
      loading.value = true
      error.value = null

      const { email, reseturl } = params
      await kftApiRequest('v1/password-forgot', {
        body: { email, reseturl },
      })

      error.value = null
    } catch (err) {
      error.value = err?.response?._data || err
    } finally {
      loading.value = false
    }
  }

  const resetPassword = async (params: {
    password: string
    passwordConfirmation: string
    token: string
    email: string
  }) => {
    try {
      loading.value = true
      error.value = null

      const { password, passwordConfirmation, token, email } = params

      await kftApiRequest('v1/password-reset', {
        body: {
          password,
          email,
          password_confirmation: passwordConfirmation,
          token,
        },
      })

      error.value = null
    } catch (err) {
      error.value = err?.response?._data || err
    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    error,
    requestPasswordReset,
    resetPassword,
  }
}
